import { onMounted, onUnmounted } from 'vue';

type ShortcutKey = 'space' | 'left' | 'right' | 'escape';

const KEY_MAP: Record<string, ShortcutKey> = {
  ' ': 'space',
  'ArrowLeft': 'left',
  'ArrowRight': 'right',
  'Escape': 'escape',
};

// 旧 vue-shortkey の prevent 判定を拡張したもの
// テキスト入力中はショートカットを発火させないため、編集可能な要素を広く除外する。
const EDITABLE_INPUT_TYPES: ReadonlyArray<string> = [
  'text',
  'password',
  'email',
  'number',
  'search',
  'url',
  'tel',
];

const isEditableElement = (el: EventTarget | null): boolean => {
  if (el instanceof HTMLTextAreaElement) return true;
  if (el instanceof HTMLSelectElement) return true;
  if (el instanceof HTMLInputElement) return EDITABLE_INPUT_TYPES.includes(el.type);
  return el instanceof HTMLElement && el.isContentEditable;
};

// space はページスクロール、矢印キーは横スクロール等のデフォルト動作を伴うため抑止する。
const PREVENT_DEFAULT_KEYS: ReadonlyArray<ShortcutKey> = [
  'space',
  'left',
  'right',
];

export const useShortcutKey = (handler: (srcKey: string) => void): void => {
  const handleKeydown = (e: KeyboardEvent) => {
    if (isEditableElement(e.target)) return;
    const srcKey = KEY_MAP[e.key];
    if (!srcKey) return;
    if (PREVENT_DEFAULT_KEYS.includes(srcKey)) e.preventDefault();
    handler(srcKey);
  };
  onMounted(() => document.addEventListener('keydown', handleKeydown));
  onUnmounted(() => document.removeEventListener('keydown', handleKeydown));
};
